// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container__ACK1_","description":"index_description__d6P6i","list":"index_list__2xlCE"};